import { useEffect, useState } from "react";
import { OrderContent } from "../../order/OrderList";
import { templateTransactionData } from "../../../data/order/transactionTableData";
import CommonPaginationSection from "../../common/CommonPaginationSection";
import { useTours } from "../../../hooks/useTours";
import { templateTourOrderData as templateTourOrderTableData } from "../../../data/order/tours/tourOrdersData";
import { templateTourOrderData } from "../../../data/order/ordersData";
import TourMenu from "../../order/menu/TourMenu";
import { TourOrderDetailModal } from "../tourOrderDetails/TourOrderDetailModal";
import { CancelPendingTourBookingModal } from "../CancelPendingTourBookingModal";
import { PayTourBookingModal } from "../PayTourBookingModal";
import { UpdateFareTourBookingModal } from "../UpdateFareTourBookingModal";
import SM from "../../DIsplay/Screen/SM";

function CustomerDetailOrdersTourList({ data: accountData }) {
  const { getTourBookings } = useTours();
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 30,
  });

  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);

  const loadData = async () => {
    const res = await getTourBookings(
      {
        limit: pagination.perPage,
        offset: ((pagination.page || 0) - 1) * pagination.perPage,
        account: accountData?._id,
      },
      setLoading
    );
    const [data, total] = res;

    if (total) {
      setPagination({ ...pagination, total });
    }
    if (data) {
      setOgData(data);
      setOrders(
        data
          ?.map((item) => templateTourOrderData(item))
          ?.map((item) => templateTourOrderTableData(item))
      );
    }
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  if (loading)
    return (
      <div className="w-full flex items-center justify-center py-6">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders.map((order, index) => (
          <Order key={index} order={order} og={ogData?.at(index)} />
        ))}
      </div>
      <CommonPaginationSection
        perPage={pagination.perPage}
        total={pagination.total}
        page={pagination.page}
        callback={(pg, perPage) =>
          setPagination({ ...pagination, page: pg, perPage })
        }
      />
    </div>
  );
}

export default CustomerDetailOrdersTourList;

const Order = ({ order, og }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewTourOrder, setViewTourOrder] = useState(false);
  const [cancelPendingTourOrder, setCancelPendingTourOrder] = useState(false);
  const [payTourOrder, setPayTourOrder] = useState(false);
  const [updateFareTourOrder, setUpdateFareTourOrder] = useState(false);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="w-full flex  justify-between bg-white p-2 py-4 lg:p-4 gap-3 rounded-md">
      <>
        <TourOrderDetailModal
          open={viewTourOrder}
          booking={og}
          setOpen={setViewTourOrder}
        />
        <CancelPendingTourBookingModal
          open={cancelPendingTourOrder}
          booking={og}
          setOpen={setCancelPendingTourOrder}
        />
        <PayTourBookingModal
          open={payTourOrder}
          booking={og}
          setOpen={setPayTourOrder}
        />
        <UpdateFareTourBookingModal
          open={updateFareTourOrder}
          booking={og}
          setOpen={setUpdateFareTourOrder}
        />
      </>
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !expand && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              expand && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex flex-col justify-between items-center `}
      >
        <button
          className="cursor-pointer p-2 relative "
          disabled={loading}
          onClick={() => setOpen(true)}
        >
          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
          {open && (
            <TourMenu
              order={og}
              //  {...{ mobile }}
              setViewTourOrder={setViewTourOrder}
              setCancelPendingTourOrder={setCancelPendingTourOrder}
              setPayTourOrder={setPayTourOrder}
              setUpdateFareTourOrder={setUpdateFareTourOrder}
              setLoading={setLoading}
            />
          )}
          {/* <SM className="">
          </SM> */}
        </button>
        <button
          className="flex lg:hidden"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-5 object-contain transition-all ${
              expand ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>
    </div>
  );
};
